import { createSlice } from '@reduxjs/toolkit'
import { type IAuthToken, type IUserProfile } from '../api/types'

interface IUserState {
  user: IUserProfile | null
  products: null
  prices: null
  subscriptions: null
  authToken: IAuthToken | null
}

const initialState: IUserState = {
  user: null,
  products: null,
  prices: null,
  subscriptions: null,
  authToken: null
}

export const userSlice = createSlice({
  initialState,
  name: 'auth',
  reducers: {
    logout: () => initialState,
    setUser: (state, action) => {
      const user = action.payload
      state.user = user
    },
    setProducts: (state, action) => {
      const products = action.payload
      state.products = products
    },
    setPrices: (state, action) => {
      const prices = action.payload
      state.prices = prices
    },
    getSubscriptions: (state, action) => {
      const subscriptions = action.payload
      state.subscriptions = subscriptions
    },
    getAuthToken: (state, action) => {
      const authToken = action.payload
      state.authToken = authToken
    }
  }
})

export default userSlice.reducer

export const { logout, setUser, setProducts, setPrices, getSubscriptions, getAuthToken } = userSlice.actions
export const selectCurrentUser = (state: { auth: { user: IUserProfile } }) => state.auth.user
